!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.af = a());
}(this, function () {
  "use strict";

  return [{
    locale: "af",
    pluralRuleFunction: function (e, a) {
      return a ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "jaar",
        relative: {
          0: "hierdie jaar",
          1: "volgende jaar",
          "-1": "verlede jaar"
        },
        relativeTime: {
          future: {
            one: "oor {0} jaar",
            other: "oor {0} jaar"
          },
          past: {
            one: "{0} jaar gelede",
            other: "{0} jaar gelede"
          }
        }
      },
      "year-short": {
        displayName: "j.",
        relative: {
          0: "hierdie jaar",
          1: "volgende jaar",
          "-1": "verlede jaar"
        },
        relativeTime: {
          future: {
            one: "oor {0} j.",
            other: "oor {0} j."
          },
          past: {
            one: "{0} j. gelede",
            other: "{0} j. gelede"
          }
        }
      },
      month: {
        displayName: "maand",
        relative: {
          0: "vandeesmaand",
          1: "volgende maand",
          "-1": "verlede maand"
        },
        relativeTime: {
          future: {
            one: "oor {0} maand",
            other: "oor {0} maande"
          },
          past: {
            one: "{0} maand gelede",
            other: "{0} maande gelede"
          }
        }
      },
      "month-short": {
        displayName: "md.",
        relative: {
          0: "vandeesmaand",
          1: "volgende maand",
          "-1": "verlede maand"
        },
        relativeTime: {
          future: {
            one: "oor {0} md.",
            other: "oor {0} md."
          },
          past: {
            one: "{0} md. gelede",
            other: "{0} md. gelede"
          }
        }
      },
      day: {
        displayName: "dag",
        relative: {
          0: "vandag",
          1: "môre",
          2: "oormôre",
          "-2": "eergister",
          "-1": "gister"
        },
        relativeTime: {
          future: {
            one: "oor {0} dag",
            other: "oor {0} dae"
          },
          past: {
            one: "{0} dag gelede",
            other: "{0} dae gelede"
          }
        }
      },
      "day-short": {
        displayName: "d.",
        relative: {
          0: "vandag",
          1: "môre",
          2: "oormôre",
          "-2": "eergister",
          "-1": "gister"
        },
        relativeTime: {
          future: {
            one: "oor {0} dag",
            other: "oor {0} dae"
          },
          past: {
            one: "{0} dag gelede",
            other: "{0} dae gelede"
          }
        }
      },
      hour: {
        displayName: "uur",
        relative: {
          0: "hierdie uur"
        },
        relativeTime: {
          future: {
            one: "oor {0} uur",
            other: "oor {0} uur"
          },
          past: {
            one: "{0} uur gelede",
            other: "{0} uur gelede"
          }
        }
      },
      "hour-short": {
        displayName: "u.",
        relative: {
          0: "hierdie uur"
        },
        relativeTime: {
          future: {
            one: "oor {0} u.",
            other: "oor {0} u."
          },
          past: {
            one: "{0} u. gelede",
            other: "{0} u. gelede"
          }
        }
      },
      minute: {
        displayName: "minuut",
        relative: {
          0: "hierdie minuut"
        },
        relativeTime: {
          future: {
            one: "oor {0} minuut",
            other: "oor {0} minute"
          },
          past: {
            one: "{0} minuut gelede",
            other: "{0} minute gelede"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "hierdie minuut"
        },
        relativeTime: {
          future: {
            one: "oor {0} min.",
            other: "oor {0} min."
          },
          past: {
            one: "{0} min. gelede",
            other: "{0} min. gelede"
          }
        }
      },
      second: {
        displayName: "sekonde",
        relative: {
          0: "nou"
        },
        relativeTime: {
          future: {
            one: "oor {0} sekonde",
            other: "oor {0} sekondes"
          },
          past: {
            one: "{0} sekonde gelede",
            other: "{0} sekondes gelede"
          }
        }
      },
      "second-short": {
        displayName: "s.",
        relative: {
          0: "nou"
        },
        relativeTime: {
          future: {
            one: "oor {0} s.",
            other: "oor {0} s."
          },
          past: {
            one: "{0} s. gelede",
            other: "{0} s. gelede"
          }
        }
      }
    }
  }, {
    locale: "af-NA",
    parentLocale: "af"
  }];
});